/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.

import classnames from 'classnames'

import { Motion, spring, presets } from 'react-motion'
import { HotKeys } from 'react-hotkeys'
import PropTypes from 'prop-types'
import BodyClassName from 'react-body-classname'
import IconSVG from 'svg-inline-react'

import 'styles/components/Modal.styl'

const ModalContent = React.createClass({
  mixins: [require('react-onclickoutside')],

  propTypes: {
    onClose: PropTypes.func.isRequired,
    modalContentClassName: PropTypes.string
  },

  componentDidMount() {
    return this.enableOnClickOutside()
  },

  handleClickOutside(event) {
    if (!this.props.ignoreCloseOnClickOutside) {
      return this.props.onClose()
    }
  },

  closeModal() {
    return this.props.onClose()
  },

  render() {
    return (
      <Motion style={{ size: spring(1, presets.gentle) }} defaultStyle={{ size: .9 }}>
        {interpolated => {
          return (
            <div
              className={classnames('modal-content', this.props.modalContentClassName)}
              onClick={this.props.onContentClick}
              ref={modalContent => {
                return this.modalContentRef = modalContent
              }}
              style={{ transform: `scale3d(${ interpolated.size }, ${ interpolated.size }, 1)` }}>
              {this.props.children}
            </div>
          )
        }}
      </Motion>
    )
  }
})

const Modal = React.createClass({
  propTypes: {
    fullScreen: PropTypes.bool,
    glassMode: PropTypes.bool,
    ignoreCloseOnClickOutside: PropTypes.bool
  },

  renderCloseButton() {
    return (
      <div className="close-button" onClick={this.props.onClose}>
        <IconSVG
          src={require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/navigation/close.svg')} />
      </div>
    )
  },

  render() {
    return (
      <HotKeys
        keyMap={{
          doClose: 'esc'
        }}
        handlers={{
          doClose: this.props.onClose
        }}>
        <BodyClassName
          className={classnames('modal-visible', {
            'modal-full-screen': this.props.fullScreen,
            'glass-mode-full-screen': this.props.glassMode
          })}>
          <Motion
            style={{ opacity: spring(1, presets.noWobble) }}
            defaultStyle={{ opacity: 0 }}>
            {interpolated => {
              return (
                <div className="Modal" style={{ opacity: interpolated.opacity }} tabIndex={0}>
                  {this.props.fullScreen ? this.renderCloseButton() : undefined}
                  <ModalContent {...this.props}>
                    {this.props.children}
                    {!this.props.fullScreen ? this.renderCloseButton() : undefined}
                  </ModalContent>
                </div>
              )
            }}
          </Motion>
        </BodyClassName>
      </HotKeys>
    )
  }

})

export default Modal



// WEBPACK FOOTER //
// ./src/scripts/components/Modal.js